module.exports = __webpack_public_path__ + "img/team_tur.8c42e9b8.jpg";